'use strict';

var $ = require('jquery');
require('magnific-popup');

function controller($http, $attrs) {
    const vm = this;

    const selector = '#newsletter-popup';
    const popUpContent = $(selector + ' .content');
    const origContent = $(popUpContent).html();

    vm.email = '';
    vm.submit_time = $('.newsletter__field__submit-time').val();

    vm.submit = ev => {
        ev.preventDefault();
        const data = {
            email: vm.email,
            submit_time: vm.submit_time,
            isajax: true
        };
        const result = [];

        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                result.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
            }
        }

        $.magnificPopup.open({
            items: {
                src: selector,
                type: 'inline',
            },
            open: function () {
                $(popUpContent).find('span').css('display', 'block');
            },
            close: function () {
                $(popUpContent).html(origContent);
            }
        });

        $http.post($attrs.action, result.join("&"), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(response => {
            popUpContent.text(response.data.data);
        }).catch(err => {
            if (err.data.data) {
                popUpContent.text(err.data.data);
            } else {
                popUpContent.text('Sorry, your registration could not be completed. Please email Audience Services')
            }
        });

        return false;
    }
    // $('<div id="popup-content">POPUP Content</div>').appendTo('body').magnificPopup();
    // debugger;
    return vm;
}

module.exports = [
    '$http',
    '$attrs',
    controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/NewsSignup.js